import React from 'react';
import { Avatar, Typography } from 'antd';
import { RobotOutlined } from '@ant-design/icons';
import './Chat.css';

const { Text } = Typography;

const TypingIndicator: React.FC = () => {
  return (
    <div className="typing-indicator-wrapper">
      <Avatar
        size="small"
        icon={<RobotOutlined />}
        style={{ backgroundColor: '#1890ff', marginRight: 8 }}
      />
      <div className="typing-indicator">
        <Text type="secondary">Agente Kardio está escribiendo</Text>
        <span className="typing-dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </div>
    </div>
  );
};

export default TypingIndicator;
